/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type StorefrontArticleSection_seller$ref = any;
export type StorefrontArticleSection_seller = {
    readonly sellerPreferences: {
        readonly hasShopTalk: unknown | null;
        readonly shopTalkUrl: string | null;
        readonly shopTalkLabel: string | null;
        readonly hasOther: unknown | null;
        readonly otherUrl: string | null;
        readonly otherLabel: string | null;
    } | null;
    readonly " $refType": StorefrontArticleSection_seller$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StorefrontArticleSection_seller",
    "type": "Seller",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "sellerPreferences",
            "storageKey": null,
            "args": null,
            "concreteType": "SellerPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasShopTalk",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "shopTalkUrl",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "shopTalkLabel",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasOther",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "otherUrl",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "otherLabel",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '37accea74a98c20fe166b4720f7cbad8';
export default node;
